import React, {useState, useEffect} from "react";

const TalentPoolWelcome = () => {
    const [view, setView] = useState(0);

    useEffect(() => {
        const preferences = TB.storedPreferences();
        if (!!preferences.hide_talent_pool_welcome) {
            setView(1);
        }
    }, [])

    const handleDontShowAgain = () => {
        TB.persistStoredPreferences({hide_talent_pool_welcome: true});
        setView(view + 1);
    }


    return (
        <div className="bg-white p-8 md:p-16">
            {view === 0 && (
                <>
                    <h1 className="text-3xl font-bold">
                        Introducing Talent Pools
                    </h1>

                    <div className="my-12">
                        <img src="/images/heads.png" className="m-auto" alt=""/>
                    </div>

                    <div className="flex flex-col gap-7">
                        <p className="text-sm">
                            Talent pools are a great way for your organization to swiftly and easily share proven
                            talent resources between projects.
                        </p>

                        <div className="flex flex-col gap-4">
                            <h3 className="text-xl text-wripplePrimaryDarkPurple">
                                Keep Talent Organized
                            </h3>
                            <p className="text-sm">
                                Create Pools for Talent based on skills, project types, and common team structures.
                                Share pools within your company to aid in the researching and hiring processes. Expedite
                                project initiation by rapidly rehiring individuals you've worked with before.
                            </p>
                        </div>

                        <div className="flex flex-col gap-4">
                            <h3 className="text-xl text-wripplePrimaryDarkPurple">
                                Bring Your Own Talent
                            </h3>
                            <p className="text-sm">
                                Use the Talent Invitations menu item to add Talent you've already worked with to the
                                Wripple Client Platform, then Invite them to your Talent Pools once they've
                                accepted.
                            </p>
                        </div>
                    </div>

                    <div className="flex justify-center mt-14">
                        <button
                            type="button"
                            onClick={handleDontShowAgain}
                            className="btn btn-primary w-1/2"
                        >
                            Don't Show this Again
                        </button>
                    </div>
                </>
            )}
            {view === 1 && (
                <>
                    <h1 className="text-3xl font-bold">
                        Creating Personal vs Company Talent Pools
                    </h1>

                    <div className="my-12">
                        <img src="/images/talent-pools/talent_pool.png" className="m-auto max-h-[340px]" alt=""/>
                    </div>

                    <div className="flex flex-col gap-7">
                        <p className="text-sm">
                            Every Talent Pool you create is either a Personal or Company Talent Pool. Your
                            Favorites, Past Hires, and the Talent you’ve invited to join the Wripple platform are also
                            automatically added to your general “Talent Pools” on the left.
                        </p>

                        <div className="flex flex-col gap-4">
                            <h3 className="text-xl text-wripplePrimaryDarkPurple">
                                Personal Talent Pools
                            </h3>
                            <p className="text-sm">
                                You can see your Personal Pools under “Personal Talent Pools” in the lefthand menu.
                                These are visible only to you. </p>
                        </div>

                        <div className="flex flex-col gap-4">
                            <h3 className="text-xl text-wripplePrimaryDarkPurple">
                                Company Talent Pools
                            </h3>
                            <p className="text-sm">
                                Company Talent Pools are visible to everyone in your organization. At this time, any
                                user can create both personal and company talent pools.
                            </p>
                        </div>
                    </div>

                    {/* <div className="flex justify-center mt-14">
                        <button
                            type="button"
                            onClick={() => console.log('update localstorage')}
                            className="btn btn-primary w-1/2"
                        >
                            Don't Show this Again
                        </button>
                    </div> */}
                </>

            )}
        </div>
    )
}

export default TalentPoolWelcome;